<template>
	<div
			v-if="item.type === 'divider' && item.label.length > 0"
			class="form-element-label"
	>
		{{ item.label }}
	</div>
	<label
			v-else-if="item.label.length > 0"
			:for="forId" class="form-element-label"
	>
		{{ item.label }}
		<span v-if="showOptionalLabel" class="optional">(optioneel)</span>
	</label>
</template>
<script lang="ts" setup>
	import type {PropType} from 'vue';
	import type {FormElementItem} from '~/lib/types/formTypes';

	defineProps({
		item: {
			type: Object as PropType<Pick<FormElementItem, 'label' | 'type'>>,
			required: true
		},
		forId: {
			type: String,
			required: true
		},
		showOptionalLabel: {
			type: Boolean,
			default: false
		}
	});
</script>

<style scoped>
	.form-element-label {
		font-size: 13px;
		line-height: 16px;
		padding: 2px 0;
		font-weight: 500;
		color: var(--color-grey-500);
	}

	.optional {
		color: var(--color-grey-300);
		font-weight: normal;
	}
</style>
